import React, { Component } from 'react'
import { Grid,Row,Col,Button,Panel,FormGroup,InputGroup,FormControl } from 'react-bootstrap'
import { API_ROOT } from '../../config.js'
import { Helmet } from 'react-helmet'

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: localStorage.getItem("userName") === null? '': localStorage.getItem("userName"),
      lastName: localStorage.getItem("userLastName") === null? '': localStorage.getItem("userLastName"),
      email: localStorage.getItem("userEmail") === null? '': localStorage.getItem("userEmail"),
      password: '',
      blnFirstName: null,
      blnLastName: null,
      blnEmail: null,
      blnPassword: null,
      blnRedirect: false
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const tvalue = target.type === 'checkbox' ? target.checked : target.value;
    const tname = target.id;

    this.setState({
      [tname]: tvalue
    })

    if(tname === 'firstName' && this.state.blnFirstName !== null && tvalue.length > 0){
      this.setState({blnFirstName: null})
      localStorage.setItem('userName', tvalue)
    }
    if(tname === 'lastName' && this.state.blnLastName !== null && tvalue.length > 0){
      this.setState({blnLastName: null})
      localStorage.setItem('userLastName', tvalue)
    }
    if(tname === 'email' && this.state.blnEmail !== null && tvalue.length > 0){
      this.setState({blnEmail: null})
      localStorage.setItem('userEmail', tvalue)
    }
    if(tname === 'password' && this.state.blnPassword !== null && tvalue.length >= 8){
      this.setState({blnPassword: null})
    }

    //console.log(this.state);
  }

  handleFormSubmit(event) {
    event.preventDefault()

    var blnError = false
    this.setState({errorMessage: ''})
    var errorMessage = 'Please fill in'

    if(this.state.firstName.length === 0){
      this.setState({blnFirstName: 'error'});
      errorMessage += ' first name,'
      blnError = true
    }
    if(this.state.lastName.length === 0){
      this.setState({blnLastName: 'error'});
      errorMessage += ' last name,'
      blnError = true
    }
    if(this.state.email.length === 0){
      this.setState({blnEmail: 'error'});
      errorMessage += ' email,'
      blnError = true
    }
    if(this.state.password.length < 8){
      this.setState({blnPassword: 'error'});
      errorMessage += ' password (min 8 characters),'
      blnError = true
    }
    if(blnError === true){
      this.setState({errorMessage: errorMessage.substring(0, errorMessage.length-1) + '.'})
      return
    }

    fetch(`${API_ROOT}/signup`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      body: JSON.stringify(this.state),
    })
    .then ( response => {
      if ( response.ok ) {
        this.setState({blnRedirect:true})
        return response.json();
      }
    })
    .catch((error) =>{
      //console.error(error);
    })
  }

  render() {
    document.title = 'New user sign up - Naleycards Malaysia'
    return (
      <React.Fragment>

      <Helmet>
        <link rel="canonical" href="https://www.naleycards.com/signup" />
        <meta name="description" content="New user sign up, welcome to NaleyCards!"></meta>
      </Helmet>

      <Grid fluid>
        <Row>
          <Col xs={12} sm={12} md={3} lg={4}></Col>
          <Col xs={12} sm={12} md={6} lg={4}>
            <Panel bsStyle="info">
              <Panel.Heading>
                <Panel.Title>Sign Up</Panel.Title>
              </Panel.Heading>

              <form onSubmit={(event) => this.handleFormSubmit(event)}>
              <Panel.Body>

                <FormGroup controlId="firstName" validationState={this.state.blnFirstName}>
                  <InputGroup>
                    <InputGroup.Addon bsClass="input-group-addon addon-text">First Name</InputGroup.Addon>
                    <FormControl type="text" value={this.state.firstName} onChange={(event) => this.handleInputChange(event)} />
                  </InputGroup>
                </FormGroup>
                <FormGroup controlId="lastName" validationState={this.state.blnLastName}>
                  <InputGroup>
                    <InputGroup.Addon bsClass="input-group-addon addon-text">Last Name</InputGroup.Addon>
                    <FormControl type="text" value={this.state.lastName} onChange={(event) => this.handleInputChange(event)} />
                  </InputGroup>
                </FormGroup>
                <FormGroup controlId="email" validationState={this.state.blnEmail}>
                  <InputGroup>
                    <InputGroup.Addon bsClass="input-group-addon addon-text">Email</InputGroup.Addon>
                    <FormControl type="text" value={this.state.email} onChange={(event) => this.handleInputChange(event)} />
                  </InputGroup>
                </FormGroup>
                <FormGroup controlId="password" validationState={this.state.blnPassword}>
                  <InputGroup>
                    <InputGroup.Addon bsClass="input-group-addon addon-text">Password</InputGroup.Addon>
                    <FormControl type="password" value={this.state.password} onChange={(event) => this.handleInputChange(event)} />
                  </InputGroup>
                </FormGroup>
                <span className="nl-button">
                  <span className="error">{this.state.errorMessage}</span>
                  <Button block bsSize="lg" type="submit">
                    Signup
                  </Button>
                </span>

              </Panel.Body>
              </form>
            </Panel>
          </Col>
          <Col xs={12} sm={12} md={3} lg={4}></Col>
        </Row>
      </Grid>

      </React.Fragment>
    )
  }
}

export default Signup
